<style scoped>
    .container{
        display: inline-block;
        vertical-align: top;
    }
    .text{
        display: inline-block;
        vertical-align: middle;
    }
    .result{
        margin-top: 5px;
    }
    .result-text{
        white-space: pre-line;
        text-align: left;
        display: block;
    }
</style>
<template>
    <div class="container">
        <Poptip placement="bottom" width="300">
            <Button size="small" icon="md-link">关联主合同</Button>
            <div class="pop-tip-content" slot="content">
                <i-input v-model="search_text" @on-enter="search" placeholder="请输入关键字搜索合同">
                    <span slot="prepend">搜索</span>
                    <Button slot="append" @click="search" :loading="searching">确定</Button>
                </i-input>
                <div class="result-container">
                    <div class="line" v-for="contract in search_results" :key="contract.id">
                        <Button size="small" class="result" long
                            @click="setItem(contract)">
                            <span class="result-text">{{contract.uid}}-{{contract.name}}</span>
                        </Button>
                    </div>
                </div>
            </div>
        </Poptip>
        <div class="text" v-if="parent_contract.id">
            <span>{{parent_contract.uid}}-{{parent_contract.name}}</span>
            <Poptip
                confirm
                transfer
                title="你确认要取消关联吗?"
                @on-ok="removeLink">
                <Button size="small" type="warning">取消关联</Button>
            </Poptip>
        </div>
    </div>
</template>
<script>
    import Util from '../../../libs/util';
    export default {
        props: {
            parent_contract: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                search_text: '',
                search_results: [],
                searching: false
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            search(){
                this.searching = true;
                Util.ajax.get(Util.api.search_contract, {
                    params: {
                        search: this.search_text
                    }
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    this.searching = false;
                    this.search_results = [];
                    if(res.code === 1){
                        let data = res.data;
                        data.contracts.forEach((item)=>{
                            this.search_results.push(item);
                        })
                    }else{
                        this.$Modal.error({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    this.searching = false;
                    this.$Modal.error({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            setItem(contract){
                Object.assign(this.parent_contract, contract);
                document.body.click();
            },
            removeLink(){
                this.parent_contract.id = 0;
            }
        }
    }
</script>
